import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin" && user.role !== "super_admin")
    return <Navigate to="/omzet" replace />;
  return children;
}
